require('../../modules/es7.symbol.async-iterator');
module.exports = require('../../modules/_wks-ext').f('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/fn/symbol/async-iterator.js
// module id = 1918
// module chunks = 2 3